import { useState } from "react";
import { ASSETS_LIB_TABS, EDITOR_VIEW_NAME } from "../../core/constants";
import { translate } from "../../core/i18n";
import { store } from "../../core/state";
import { getViewData, setViewData } from "../../core/views";
import { CloseButton } from "../buttons/base/CloseButton";
import { CLICK_EVENT, requestNextStep } from "../StepPopper";
import { AssetLibEntry } from "./AssetLibEntry";

export const AssetsLib = () => {
  const [assetLibData, setAssetLibData] = store.useState(ASSETS_LIB_TABS);
  const [searchFilter, setSearchFilter] = useState("");

  const closeAssetsLib = () => {
    const editorState = getViewData(EDITOR_VIEW_NAME);
    editorState.data = {
      ...editorState.data,
      assetsVisible : false
    }
    setViewData(EDITOR_VIEW_NAME, editorState);
    requestNextStep(CLICK_EVENT, "close-asset-lib")
  }

  const showTab = (data : any) => {    
    const newState = {...assetLibData }
    newState.currentTab = data;
    newState.currentCategory = null;
    setAssetLibData(newState);
  }

  const showCategory = (category : any) => {
    const newState = {...assetLibData }
    newState.currentCategory = category;
    setAssetLibData(newState);
  }

  const filterAssets = (e : React.KeyboardEvent<HTMLInputElement>) => {
    const searchInput : HTMLInputElement = e.target as HTMLInputElement;
    setSearchFilter(searchInput.value);
  }

  const tabs : any[] = [];
  assetLibData?.tabs?.forEach((tab : any) => {
    let iconContent = null;
    const tabName = translate(tab.name);
    if (tab.icon) {
      iconContent = <img className="mr-1" src={tab.icon} width={30} alt={tabName} />
    }
    const colorClass = `btn btn-${tab.color ? tab.color : "warning"} m-1`;
    const tabButton = <button className={colorClass} key={tabName} title={tabName} onClick={() => { showTab(tabName)}}>
      {iconContent}{ !iconContent && tabName}
    </button>;
    tabs.push(tabButton);
  })

  let content = [];
  let categories = null;

  if (!assetLibData?.tabs) {
    return null;
  }
  let tabContent = assetLibData?.tabs[0];
  if (assetLibData?.currentTab) {
    tabContent = assetLibData?.tabs?.find((tab : any) => translate(tab.name) === assetLibData.currentTab);
  }

  const getEntriesFromAssets = (entries) => {
    const content = [];
    if (entries.length > 0) {
      entries.forEach((tabEntry : any) => {
        const entry = <AssetLibEntry data={tabEntry} tab={tabContent} key={tabEntry.name} />;
        if (!searchFilter) {
          content.push(entry);
        } else if (tabEntry.name.indexOf(searchFilter) > -1) {
          content.push(entry);
        }
      })
    }
    return content;
  }

  if (tabContent?.data.assets) {
    content = getEntriesFromAssets(tabContent?.data.assets);
  } else if (tabContent?.data.length > 0) {
    //go through array and create another level for categories!
    const buttons = [];
    tabContent?.data.forEach((category : any) => {
      let iconContent = null;
      const catName = translate(category.name);
      if (category.icon) {
        iconContent = <img className="mr-1 assetCategory" src={category.icon} width={30} alt={catName} />
      }
      const colorClass = `btn btn-${category.color ? category.color : "secondary"} m-1`;
      const catButton = <button className={colorClass} key={catName} title={catName} onClick={() => { showCategory(catName)}}>
        {iconContent}{ !iconContent && catName}
      </button>;
      buttons.push(catButton);
    })
    categories = (<>
      <div className="row">
        <div className="center" id="assetCategories" >
          { buttons }
        </div>
      </div>
      <hr />
    </>);

    let catContent = tabContent?.data[0];
    if (assetLibData?.currentCategory) {
      catContent = tabContent?.data?.find((cat : any) => translate(cat.name) === assetLibData.currentCategory);
    }
    content = getEntriesFromAssets(catContent?.assets);
  }

  return (
    <div id="assetcontent">
      <div className="container">
        <div className="row" id="grid">
          <div className="col-11">
            <input id="gridsearch" type="text" className="form-control mb-10 gridsearch" placeholder={translate("asset-search")} onKeyUp={filterAssets} />
          </div>
          <div className="col-1">
            <CloseButton id='btn-close-assets' onClick={closeAssetsLib} />
          </div>
        </div>
        <div className="row">
          <div className="center" id="assetTabs" >
            { tabs }
          </div>
        </div>
        <hr />
        { categories }
        <div className="row">
          <div className="col">
            <div id="tabbody" className="row scrollable-library">{content}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
